import { sx } from '../../../ui/designStyles';
import { AboutThis } from '../../../ui/AboutThis';
import { A, type IntelTab, type TabProps } from '../common';

/** A Simulate mode button (V4 aiDealVals seg). */
export const seg = (on: boolean) =>
  'display:inline-flex;align-items:center;height:30px;padding:0 12px;border-radius:7px;font-size:16px;text-decoration:none;white-space:nowrap;' +
  (on ? 'font-weight:700;color:#fff;background:#2F5C97;' : 'font-weight:600;color:#3C454F;background:rgba(34,39,46,.06);');

/** A small segment (sector, loan). */
export const segS = (on: boolean) =>
  'display:inline-flex;align-items:center;height:24px;padding:0 9px;border-radius:6px;font-size:14px;text-decoration:none;white-space:nowrap;' +
  (on ? 'font-weight:700;color:#2F5C97;background:rgba(79,138,214,.14);' : 'font-weight:600;color:#54606C;background:rgba(34,39,46,.05);');

const MODES: [IntelTab, string][] = [
  ['deal', 'Deal model'],
  ['scenario', 'Levers'],
  ['simulate', 'Track live'],
];

/** Simulate's three modes (V4 dsShowBar): Deal model, Levers, Track live. Never shown to Sales. */
export function ModeBar({ p, tab }: { p: TabProps; tab: IntelTab }) {
  if (p.sales) return null;
  return (
    <div style={sx('display:flex;align-items:center;gap:6px;flex-wrap:wrap;row-gap:6px;margin-bottom:10px;')}>
      {MODES.map(([k, label]) => (
        <A key={k} onClick={() => p.go(k)} style={seg(tab === k)}>
          {label}
        </A>
      ))}
      {/* V9: the explainer opens on the "i" (design k17162). */}
      <AboutThis inline textStyle="font-size:14px;color:#54606C;margin-left:6px;">
        Deal model values the purchase. Levers tests operating changes. Track live follows a saved plan against real months.
      </AboutThis>
    </div>
  );
}
